<template>
  <div class="rate-code-matrix-manager">
    <tag-form-modal
      :firm-id="contract.contractee_firm_id"
      type="[RATE][CATEGORY]"
      @create="onCategoryCreate"
      ref="tagFormModal"
    >
      <template #header>
        ADD CATEGORY
      </template>
    </tag-form-modal>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field grouped>
          <b-button @click="onAddCategory">
            ADD CATEGORY
          </b-button>
        </b-field>
        <b-field grouped>
          <!-- <base-select
            :service="$options.rateService"
            fetch-func="listCategories"
            label="Rates"
            label-key="category"
            :value.sync="rateCategory"
            value-key="category"
            default-option-label="All"
            style="width: 200px;"
          /> -->
          <base-select
            :service="$options.codeService"
            fetch-func="listTypes"
            label="Codes"
            label-key="type"
            :value.sync="codeType"
            value-key="type"
            default-option-label="All"
          />
          <div class="field is-expanded">
            <label class="label" style="visibility: hidden">ACTIONS</label>
            <p class="control">
              <b-button :loading="loading" @click="set">
                SET
              </b-button>
            </p>
          </div>
        </b-field>
      </div>
      <div class="column is-12">
        <matrix
          :columns="matrixColumns"
          :rows="matrixRows"
          :associations="matrixAssociations"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Matrix from "@/components/MatrixManager/MatrixManagerMatrix";
import BaseSelect from "@/components/partials/BaseSelect";
import TagFormModal from "@/components/Tag/TagFormModal";
import { CodeService } from "@/services/code.service";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  rateService: OrderOperationClaimServiceService,
  props: {
    contract: {
      type: Object
    }
  },
  components: {
    BaseSelect,
    Matrix,
    TagFormModal,
  },
  data: () => ({
    rateCategory: "",
    codeType: "",
    matrixRows: [],
    matrixColumns: [],
    matrixAssociations: [],
    loading: false
  }),
  methods: {
    fetchRates() {
      return this.$options.rateService
        .all({
          firm_id: this.contract.contractor_firm_id,
          contract_id: this.contract.id,
          category: this.rateCategory || undefined,
          includes: "codes"
        })
        .then(response => JsonDenormalizer.denormalize(response));
    },
    fetchRateCategoryTags() {
      return this.$options.rateService
        .listCategoryTags({ firm_id: this.contract.contractee_firm_id, includes: "codes" })
        .then(response => JsonDenormalizer.denormalize(response));
    },
    fetchCodes() {
      return this.$options.codeService
        .all({
          contract_id: this.contract.id,
          type: this.codeType || undefined,
          inactive: 1,
          includes: "tags"
        })
        .then(response => JsonDenormalizer.denormalize(response));
    },
    async set() {
      this.loading = true;

      const values = await Promise.all([
        this.fetchRateCategoryTags(),
        this.fetchCodes(),
      ]);

      // this.matrixRows = _.sortBy(values[0], ["category", "ninaCode"]); // rates
      this.matrixRows = _.sortBy(values[0], ["name"]); // rate category tags
      // HACK - display ninaCode in matrix
      this.matrixRows = this.matrixRows.map(v => ({ ...v, code: v.name, status: 1 }));
      this.matrixColumns = _.sortBy(values[1], ["group", "code"]); // codes

      this.getMatrixAssociations();

      this.loading = false;
    },
    getMatrixAssociations() {
      this.matrixAssociations = this.matrixRows.reduce((acc, rateCategoryTag) => {
        const associations = [];
        // const rateCodes = rate.codes || [];
        const rateCategoryTagCodes = rateCategoryTag.codes || [];

        this.matrixColumns.forEach(code => {
          // const codeRates = code.rates || [];
          // const association =
          //   // Check if code is a child of rate
          //   codeRates.find(child => child.id === rate.id) &&
          //   // Check if rate is a parent of code (reverse)
          //   codeRates.find(parent => parent.id === code.id);

          // Just check if code is related to rate (no reverse)
          // const association = rateCodes.find(v => v.id == code.id);
          const association = rateCategoryTagCodes.find(v => v.id == code.id);
          associations.push(!!association);
        });

        acc.push(associations);

        return acc;
      }, []);
    },
    onAddCategory() {
      this.$refs.tagFormModal.open();
    },
    onCategoryCreate() {
      if (this.codeType) {
        this.set();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MatrixManager/RateCodeMatrixManager.vue